import styled from 'styled-components';

const Label = styled.label`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0,0,0,0);
  white-space: nowrap;
  clip-path: inset(50%);
  border: 0;
`;

export default Label;


// WEBPACK FOOTER //
// ./src/components/Form/FormLabel.js